import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingScreen = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-6">
        <div className="flex justify-center">
          <img
            src="/lr-logo-new.png"
            alt="L&R People.Health.Care. Logo"
            className="h-12 w-auto"
          />
        </div>
        <div className="flex justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
        <p className="text-sm text-muted-foreground">
          Anmeldung wird verarbeitet...
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;
